import { render, staticRenderFns } from "./TestLogin.vue?vue&type=template&id=8b448e70&scoped=true&"
import script from "./TestLogin.vue?vue&type=script&lang=js&"
export * from "./TestLogin.vue?vue&type=script&lang=js&"
import style0 from "./TestLogin.vue?vue&type=style&index=0&id=8b448e70&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b448e70",
  null
  
)

export default component.exports